import Layout from "../layouts/LayoutDefault.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import MainContainer from "../components/MainContainer.jsx";
import TitleTextSection from "../components/TitelTextSection.jsx";
import { FaSpotify, FaUsers, FaPlus, FaMusic } from "react-icons/fa6";
import { MdOpenInNew } from "react-icons/md";

const Playlist = () => {
  const city = "Strängnäs kommun";

  const { data: data } = MakeGetRequest({
    route: `get_playlists`,
  });

  return (
    <>
      <Layout
        title="Lokults egna Spellista"
        description="Din lokalaste spellista på Spotify. Uppdateras varje fredag."
      >
        <MainContainer>
          {/* Hero */}
          <div className="sm:py-4 mb-8">
            <TitleTextSection
              title={`${city}listan`}
              subtitle="Din lokalaste spellista på Spotify — uppdateras varje fredag"
            />
          </div>

          {/* Spotify CTA card */}
          <div className="mb-8 p-6 rounded-2xl border border-base-content/10 bg-base-200 flex flex-col sm:flex-row items-center gap-6">
            <FaSpotify size={72} className="text-[#1ed760] shrink-0" />
            <div className="flex-1 text-center sm:text-left">
              <h2 className="text-xl font-semibold mb-1">
                Spotifylistan där vi samlar {city}s musik
              </h2>
              <p className="text-base-content/70 text-sm max-w-xl">
                Varje artist på Lokult får välja ut två av sina låtar som hamnar
                på listan. Följ listan för att hålla dig uppdaterad och kanske
                hittar du din nya favoritartist.
              </p>
            </div>
            <a
              aria-label="öppnar spotifyspellistan"
              href="https://open.spotify.com/playlist/2e6h9i7PeVcX3kTHvedc8W?si=69ac04c181cd433f"
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 "
            >
              <button className="btn btn-wide font-bold uppercase text-secondary">
                Öppna Spellistan <MdOpenInNew size={18} />
              </button>
            </a>
          </div>

          {/* Stats */}
          {data && (
            <div className="mb-8 grid grid-cols-3 gap-4">
              <div className="rounded-2xl border border-base-content/10 bg-base-200 p-5 flex flex-col items-center gap-1">
                <FaMusic size={20} className="text-base-content/50 mb-1" />
                <span className="text-3xl font-bold">
                  {data.stats?.total_songs ?? "—"}
                </span>
                <span className="text-xs text-base-content/50 uppercase tracking-wider">
                  Låtar
                </span>
              </div>
              <div className="rounded-2xl border border-base-content/10 bg-base-200 p-5 flex flex-col items-center gap-1">
                <FaPlus size={20} className="text-base-content/50 mb-1" />
                <span className="text-3xl font-bold">
                  {data.stats?.new_songs ?? 0}
                </span>
                <span className="text-xs text-base-content/50 uppercase tracking-wider">
                  Nya (30 dagar)
                </span>
              </div>
              <div className="rounded-2xl border border-base-content/10 bg-base-200 p-5 flex flex-col items-center gap-1">
                <FaUsers size={20} className="text-base-content/50 mb-1" />
                <span className="text-3xl font-bold">
                  {data.stats?.total_artists ?? "—"}
                </span>
                <span className="text-xs text-base-content/50 uppercase tracking-wider">
                  Artister
                </span>
              </div>
            </div>
          )}

          {/* Song table */}
          {data && (
            <div className="mb-10">
              <p className="font-semibold text-base-content/50 uppercase tracking-wider text-sm mb-3">
                Låtar på spellistan
              </p>
              <div className="overflow-x-auto rounded-2xl border border-base-content/10">
                <table className="table table-zebra">
                  <thead>
                    <tr>
                      <th className="hidden md:table-cell">#</th>
                      <th>Artist</th>
                      <th>Titel</th>
                      <th className="hidden md:table-cell">Tillagd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.songs.map((song, index) => {
                      const date = new Date(
                        song.created_at,
                      ).toLocaleDateString();
                      return (
                        <tr key={index}>
                          <td className="hidden md:table-cell text-base-content/40">
                            {index + 1}
                          </td>
                          <td className="font-medium">{song.band}</td>
                          <td>{song.title}</td>
                          <td className="hidden md:table-cell text-base-content/50">
                            {date}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </MainContainer>
      </Layout>
    </>
  );
};

export default Playlist;
